import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EmployeesTrainingPlanConstants } from '../employees-training-plan.constants';
import { EmployeesTrainingPlanPersistenceService } from '../services/employees-training-plan-persistence.service';
import { SelectedUserScopesDTO } from '../models/selectedUserScopesDTO';

@Component({
  selector: 'app-employee-training-plan-slider',
  templateUrl: './employee-training-plan-slider.component.html',
  styleUrls: ['./employee-training-plan-slider.component.scss']
})
export class EmployeeTrainingPlanSliderComponent implements OnInit {
  @Output() isTrainingPlanSliderActive = new EventEmitter<boolean>();
  @Input() isTrainingPlanSliderOpen: boolean = false;
  @Input() userScopes: SelectedUserScopesDTO | undefined;
  @Input() userPUID: string | undefined;
  errorIconClassForDocumentTab = '';
  errorIconClassForCourseTab = '';
  currentTab = 0;
  activeTab = 0;

  constructor(private employeesTrainingPlanPersistenceService: EmployeesTrainingPlanPersistenceService){

  }
  
  ngOnInit(): void {
    this.employeesTrainingPlanPersistenceService.closeAndResetTrainingPlanSlider$.subscribe((isClose) => {
      if (isClose) { this.closeAndResetTrainingPlanSlider(); }
    });

    this.employeesTrainingPlanPersistenceService.populateErrorsForTab$.subscribe((validateTabs) => {
      if(validateTabs) {
        this.showErrorIconForTab();
      }
    });
  }

  closeSlider(){
    this.closeAndResetTrainingPlanSlider();
  }

  closeAndResetTrainingPlanSlider(){
    this.isTrainingPlanSliderOpen = false;
    this.activeTab = 0;
    this.currentTab = 0;
    this.employeesTrainingPlanPersistenceService.onTabChange(-1);
    this.employeesTrainingPlanPersistenceService.onCustomTabChange(-1);
    this.isTrainingPlanSliderActive.emit(this.isTrainingPlanSliderOpen);
  }

  openCurrentTab = (tabIndex: number) => {
    this.currentTab = tabIndex;
    this.activeTab = tabIndex;
  }
  onTabChange = (event: any) => {
    this.employeesTrainingPlanPersistenceService.onTabChange(this.currentTab);
    this.employeesTrainingPlanPersistenceService.onCustomTabChange(event.index);
    this.currentTab = event.index;
  }
  showErrorIconForTab = () => {
    this.errorIconClassForDocumentTab = '';
    this.errorIconClassForCourseTab = '';
    this.employeesTrainingPlanPersistenceService.errorTabIndices.forEach((tabIndex) => {
      switch (tabIndex) {
        case EmployeesTrainingPlanConstants.TrainingPlan_Menu_Document_Tab_Index:
          this.errorIconClassForDocumentTab = 'pi pi-exclamation-triangle';
          break;
        case EmployeesTrainingPlanConstants.TrainingPlan_Menu_Course_Tab_Index:
          this.errorIconClassForCourseTab = 'pi pi-exclamation-triangle';
          break;
      }
    })
  }
}
